var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.791,
    height: 14.791,
    viewBox: "0 0 14.791 14.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sync",
    d: "M14.791,2.5V5.131a.924.924,0,0,1-.924.924H11.232a.924.924,0,0,1,0-1.849h.706a5.552,5.552,0,0,0-9.71,1.169A.924.924,0,0,1,.507,4.7,7.4,7.4,0,0,1,12.942,2.5V2.5a.924.924,0,0,1,1.849,0Zm-1.031,6.4a.924.924,0,0,0-1.2.524,5.552,5.552,0,0,1-9.644,1.261h.64a.924.924,0,0,0,0-1.849H.924A.924.924,0,0,0,0,9.753v2.635a.924.924,0,0,0,1.849,0v-.1a7.439,7.439,0,0,0,1.33,1.183A7.4,7.4,0,0,0,14.284,10.09a.924.924,0,0,0-.524-1.2Z",
    transform: "translate(0 0)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/Sync.cd031f62f4cc788dba897fade0cbda6d.svg";
export { ForwardRef as ReactComponent };